import { onlyNumbers } from "./helpers"

export default function validaData(data) {
    if (!data)
        return false;

    if (onlyNumbers(data).length < 8) {
        return false
    }
        
    if (new Date(data + "T00:00-0000") > new Date()) {
        return false
    }
        
    return true
}